<template>
  <div class="row page-wrapper">
    <div class="col-12">
      <div class="row justify-content-center page-header">
        <div class="col-xs-12 col-xl-10">
          <h3>Benutzer bearbeiten</h3>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-xs-12 col-xl-10">
          <div class="row form-wrapper">
            <div class="col-12">
              <b-form
                class="new-entity-form"
                @submit="onSubmit"
              >
                <div class="row justify-content-start">
                  <div class="col-xs-12 col-lg-6">
                    <b-form-group label="Email">
                      <b-form-input
                        v-model="formData.email"
                        :type="'email'"
                        :state="isFormEmailValid"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-xs-12 col-lg-6">
                    <b-form-group label="Name">
                      <b-form-input
                        v-model="formData.name"
                        :type="'text'"
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-lg-6">
                    <b-form-group label="Passwort">
                      <b-form-input
                        v-model="formData.password"
                        :type="'password'"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-xs-12 col-lg-6">
                    <b-form-group label="Passwort bestätigen">
                      <b-form-input
                        v-model="formData.cpassword"
                        :type="'password'"
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-lg-6">
                    <b-form-group label="Role">
                      <b-form-select 
                        v-model="formData.role" 
                        :options="userRoleOptions"
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-form-group class="form-button-group">
                      <b-button
                        variant="outline-primary"
                        class="btn-cancel"
                        @click="goBack"
                      >
                        Zurück
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary"
                        class="float-right"
                        :disabled="!isFormValid"
                      >
                        Aktualisieren
                      </b-button>
                    </b-form-group>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ROLES } from '../../constants';
import {NavigationMixin, UserMixin} from '../../mixins';
import {mapState, mapActions} from 'vuex';

export default {
  name: 'AddUser',
  mixins: [NavigationMixin, UserMixin],
  data: function () {
    return {
      formData: {
        name: null,
        role: ROLES.ADMIN,
        email: null,
        password: null
      },
      userRoleOptions: [ROLES.ADMIN, ROLES.USER]
    };
  },
  computed: {
    isFormValid() {
      return this.formData.name && this.formData.password && (this.formData.password == this.formData.cpassword) && this.formData.email && this.isEmailValid(this.formData.email) && this.formData.role;
    },
    isFormEmailValid() {
      return this.isEmailValid(this.formData.email);
    },
    ...mapState({
      selectedUser: state => state.user.selectedUser
    })
  },
  created() {
    if (this.selectedUser) {
      Object.keys(this.formData).forEach(key => this.formData[key] = this.selectedUser[key]);
    } else {
      this.loadUser();
    }
  },
  methods: {
    ...mapActions({
      setSelectedUser: 'user/setSelectedUser'
    }),
    async onSubmit(evt) {
      evt.preventDefault();
      if (this.isFormValid) {
        try {
          const payload = {...this.formData};
          await this.userService.updateUser(this.$route.params.id, payload);
          this.goToPath('/users');
        } catch (err) {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Bearbeiten Lizenz',
            text: (err && err.error) ? err.error.message : 'Failed to update the user.'
          });
        }
      }
    },
    isEmailValid(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    async loadUser() {
      try {
        const response = await this.userService.getUserById(this.$route.params.id);
        Object.keys(this.formData).forEach(key => this.formData[key] = response.user[key]);
        this.formData.password = '';
      } catch (err) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Bearbeiten Lizenz',
          text: (err && err.error) ? err.error.message : 'Failed to retrieve the license.'
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
</style>
